import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { MapPin, Star, Clock } from 'lucide-react';

const PartnerCard = ({ partner, index }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
    >
      <div className="flex items-start gap-4">
        {/* Profile Image */}
        <img
          src={partner.image}
          alt={partner.name}
          className="w-20 h-20 rounded-full object-cover"
        />

        {/* Info */}
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-gray-800 mb-1">
            {partner.name}
          </h3>
          <p className="text-sm text-gray-500 mb-2">{partner.specialty}</p>

          {/* Rating */}
          <div className="flex items-center gap-2 mb-2">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-4 h-4 ${
                    i < Math.floor(partner.rating)
                      ? 'fill-yellow-400 text-yellow-400'
                      : 'text-gray-300'
                  }`}
                />
              ))}
            </div>
            <span className="text-sm text-gray-600">
              {partner.rating} ({partner.reviews} reviews)
            </span>
          </div>

          {/* Distance */}
          <div className="flex items-center gap-2 text-sm text-gray-600 mb-3">
            <MapPin className="w-4 h-4" />
            <span>{partner.distance} km away</span>
          </div>

          {/* Availability */}
          <div className="flex items-center gap-2 mb-4">
            <Clock className="w-4 h-4 text-gray-500" />
            <span
              className={`text-sm font-medium ${
                partner.available ? 'text-green-600' : 'text-orange-600'
              }`}
            >
              {partner.available ? 'Available Now' : 'Accepting New Clients'}
            </span>
          </div>

          {/* Book Button */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate(`/booking/${partner.id}`)}
            className="w-full bg-primary text-white py-2 rounded-lg font-medium hover:bg-primary/90 transition-colors"
          >
            Book Now
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default PartnerCard;
